import { render } from "./ResetPhone.vue?vue&type=template&id=5f39f427&scoped=true"
import script from "./ResetPhone.vue?vue&type=script&lang=js"
export * from "./ResetPhone.vue?vue&type=script&lang=js"

import "./ResetPhone.vue?vue&type=style&index=0&id=5f39f427&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f39f427"]])

export default __exports__